export default class ItedDefinicoesController {
    constructor($state, AuthenticationService, UIService, ItedPreco) {
        this.$state = $state;
        this.user = AuthenticationService.getUser();
        this.UI = UIService;
        this.ItedPreco = ItedPreco;
        this.loaded = false;
        this.switchTab($state.params.tab || 'preco');
    }
    switchTab = (tab) => {
        this.params = {
            tab: tab
        };
        switch (tab) {
            case 'preco':
                this.tab = 0;
                break;
            default:
                this.tab = 0;
                break;
        }
        this.$state.go('app.administration.adminITED', this.params, {
            notify: false,
            reload: false,
            location: 'replace',
            inherit: false
        });
        this.loadData();
    };
    loadData = (tab) => {
        switch (this.params.tab) {
            case 'preco':
                this.loadPrecos();
                break;
            default:
                break;
        }
    };
    loadPrecos = () => {
        this.loaded = false;
        this.ItedPreco.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise.then(precos => {
            this.loaded = true;
            this.precos = precos;
        }).catch(() => {
            this.loaded = true;
            this.UI.addToast("Ocorreu um erro a carregar preços ITED.");
        });
    };
    editPreco = (x) => {
        let preco = angular.copy(x);
        let options = {
            size: 'md',
            template: require('./modal-edit-preco.html'),
            controller: ['$scope', $scope => {
                    $scope.title = "Editar Preço ITED";
                    $scope.preco = preco;
                    $scope.ok = () => {
                        $scope.$close($scope.preco);
                    };
                    $scope.cancel = () => {
                        $scope.$dismiss('cancel');
                    };
                }]
        };
        this.UI.showDialog(options).then(res => {
            if (res) {
                this.ItedPreco.patch({ id: res.id, valor: res.valor }).$promise.then(() => {
                    this.loadData('preco');
                    this.UI.addToast('Preço ITED editado com sucesso');
                }).catch(error => {
                    console.log(error);
                    this.UI.addToast('Erro ao editar preço. Verifique ligação');
                });
            }
        }).catch(() => {
        });
    };
}
ItedDefinicoesController.$inject = ['$state', 'AuthenticationService', 'UIService', 'ItedPreco'];
